import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MaterialTable, { MTableToolbar } from 'material-table'
import { ButtonListEdit } from 'theme'
import Edit from '@material-ui/icons/Edit'
import { ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED } from '../../actions/action-constants'
import SnackbarError from '../../components/snackbar/snackbar-error'
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'
class PostDischarges12m extends Component {
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      columns: [
        { title: 'Sys ID', field: 'id' },
        { title: 'CP / REG ID', field: 'regid' },
        { title: 'Name', field: 'lcommafname' },
        { title: 'Program', field: 'programdescription' },
        { title: 'Clnt Dschrg Dte', field: 'clientdischargedate' },
        { title: 'Clnt Dschrg Dte 90', field: 'clientdischargedate90d' },
        { title: 'Clnt Dschrg Dte 180', field: 'clientdischargedate180d' },
        { title: 'Clnt Dschrg Dte 12', field: 'clientdischargedate12m' },
        { title: 'Clnt Dschrg Dte 24', field: 'clientdischargedate24m' },
        { title: 'Clnt Dschrg Dte 36', field: 'clientdischargedate36m' },
        { title: 'Adms Dte', field: 'referralrequestedadmissiondate' },
        { title: 'Proj Rls Dte', field: 'referralprojectedreleasedate' },
        { title: 'Project LOS', field: '' }
      ]
    }
  }

  componentDidMount () {
    const c_USER = this.context
    this.props.getPostDischarges(c_USER.id)
    this.props.getProgramsAssignedToLoginList(
      c_USER.id
    )
  }

  render () {
    return (
      // <div className={classes.root}>
      <div>
        {this.props.programsAssigned.length <= 1 ? (
          <div>
            <h4>{ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}</h4>
            <SnackbarError
              variant='error'
              message={ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}
            />
          </div>
        ) : (
          <div style={{ maxWidth: '100%' }}>
            {/* <PostDischargesToolbar /> */}
            <MaterialTable
              title='Post Discharges 12 Months'
              // onRowSelected='10'
              // rowData='10'
              // rowsperpage='10'
              // rows='10'
              rowsPerPage='10'
              columns={this.state.columns}
              data={this.props.postdischarges}
              options={{
                // search
                search: true,
                // header grouping
                grouping: true,
                // or
                // column filtering
                // filtering: true,
                // CSV export
                // pagination settings
                // show paging buttons
                // paging:false,
                // default items per page
                pageSize: 10,
                // paging options
                pageSizeOptions: [10, 25, 50, 100],
                // ???
                // columnsButton:false,
                // move buttons to right side of list
                // actionsColumnIndex: -1,
                // styling otions
                rowStyle: { height: '20px' },
                maxBodyHeight: 700,
                // export data buttons
                // exportButton: true,
                // default filename
                exportFileName: 'CPCMexport-PostDischarges12m'
                // comma delimited
                // exportDelimiter: ',',
              }}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Edit Post Discharge',
                  onClick: (event, rowData) => {
                    this.props.history.push('/postdischarges/' + rowData.id)
                  }
                }
              ]}
              components={{
                Toolbar: props => (
                  // <div style={{ backgroundColor: '#e8eaf5' }}>
                  // <div style={{ backgroundColor: '#ff7961' }}>
                  // <div style={{ backgroundColor: '#f44336' }}>
                  // <div style={{ backgroundColor: '#ff7961' }}>
                  // <div style={{ backgroundColor: '#80d8f' }}>
                  // <div style={{ backgroundColor: '#a9ffa5' }}>
                  <div
                    style={{
                      background:
                        'linear-gradient(45deg, #fff59d 10%, #fff 70%)',
                      color: 'white'
                    }}>
                    <MTableToolbar {...props} />
                  </div>
                ),
                Action: props => (
                  <ButtonListEdit
                    onClick={event => props.action.onClick(event, props.data)}>
                    <Edit />
                  </ButtonListEdit>
                )
              }}
            />
          </div>
        )}
      </div>
    )
  }
}
PostDischarges12m.propTypes = {
  className: PropTypes.string
}
export default withRouter(PostDischarges12m)












/////////////////////
//   // edit button to left
//   actions={[
//     {
//       icon: 'edit',
//       tooltip: 'Edit Entry',
//       onClick: (event, rowData) => {
//         console.log('4444-901 - PostDischarges12m - MaterialTable - event = ', event);
//         console.log('4444-902 - PostDischarges12m - MaterialTable - rowData = ', rowData);

//         alert('You Edited ' + rowData.id + ' ' + rowData.description)

//       },

//       // save icon
//       // icon: 'save',
//       // tooltip: 'Save User',
//       // onClick: (event, rowData) => {
//       //   console.log('4444-901 - PostDischarges12m - MaterialTable - event = ', event);
//       //   console.log('4444-902 - PostDischarges12m - MaterialTable - rowData = ', rowData);
//       //   // Do save operation
//       // }
//     },
// ]}
////////////////////////////////

/////////////////////////////
// // import CreateIcon from '@material-ui/icons/Create';
// actions={[
//   {
//     icon: 'save',
//     tooltip: 'Save User',
//     onClick: (event, rowData) => alert("You saved " + rowData.name)
//   }
// ]}
// components={{
//   Action: props => (
//     <Button
//       onClick={(event) => props.action.onClick(event, props.data)}
//       color="primary"
//       variant="contained"
//       style={{textTransform: 'none'}}
//       size="small"
//     >
//       My Button
//     </Button>
//   ),
// }}
////////////////

///////////////////////////

// editable={{

// onRowAdd: newData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data.push(newData);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowUpdate: (newData, oldData) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data[data.indexOf(oldData)] = newData;
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowDelete: oldData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data.splice(data.indexOf(oldData), 1);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),

// onRowAdd: newData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data.push(newData);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowUpdate: (newData, oldData) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data[data.indexOf(oldData)] = newData;
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowDelete: oldData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.postdischarges];
//       data.splice(data.indexOf(oldData), 1);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
///////////////////////////////////

// }}
